import actions from '../actions';
import { ASYNC_FETCH_INITIAL_STATE, makeAsyncFetchReducer, makeReducer } from '../utils';

const INITIAL_STATE = {
  pois: ASYNC_FETCH_INITIAL_STATE,
};

const reducer = makeReducer({
  initialState: INITIAL_STATE,
  reducers    : {
    ...makeAsyncFetchReducer({
      key    : 'pois',
      init   : actions.pois.fetch.type,
      success: actions.pois.fetchSuccess.type,
      error  : actions.pois.fetchError.type,
    }),
  },
});

export default reducer;
